import { render, staticRenderFns } from "./EditDelvieryModal.vue?vue&type=template&id=d5f6358c&scoped=true&"
import script from "./EditDelvieryModal.vue?vue&type=script&lang=js&"
export * from "./EditDelvieryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f6358c",
  null
  
)

export default component.exports